import MastersCrudPageFromSameFile from "../components/MastersCrudPage"; // si separas archivos, ajusta la ruta
import {
listServices,
createService,
updateService,
deleteService,
} from "../api/mastersApi";


export function ServicesPage() {
return (
<MastersCrudPageFromSameFile
title="Servicios médicos"
fetchList={listServices}
createItem={createService}
updateItem={updateService}
deleteItem={deleteService}
modalPosition="right" // <-- aquí indicamos que el modal abra desde la derecha
columns={[
{ key: "id", label: "ID" },
{ key: "name", label: "Nombre" },
{ key: "default_duration_min", label: "Duración (min)" },
{ key: "base_price", label: "Precio consulta" },
{ key: "is_active", label: "Activo" },
]}
initialForm={() => ({ name: "", default_duration_min: 30, base_price: 0, requires_approval: 0, requires_room: 0, is_active: 1 })}
renderForm={({ form, setForm }) => (
<>
<div>
<label className="block text-xs text-gray-400">Nombre</label>
<input value={form.name} onChange={e => setForm({...form, name: e.target.value})} className="w-full p-2 rounded bg-[#020817] border border-gray-700" />
</div>


<div className="grid grid-cols-3 gap-2">
<div>
<label className="block text-xs text-gray-400">Duración (min)</label>
<input type="number" value={form.default_duration_min} onChange={e => setForm({...form, default_duration_min: Number(e.target.value)})} className="w-full p-2 rounded bg-[#020817] border border-gray-700" />
</div>
<div>
<label className="block text-xs text-gray-400">Precio de consulta</label>
<input type="number" min="0" step="0.01" value={form.base_price} onChange={e => setForm({...form, base_price: Number(e.target.value)})} className="w-full p-2 rounded bg-[#020817] border border-gray-700" />
<div className="appointment-field-hint">Este valor se copia automáticamente al crear una cita con este servicio.</div>
</div>
<div>
<label className="block text-xs text-gray-400">Activo</label>
<select value={form.is_active} onChange={e => setForm({...form, is_active: Number(e.target.value)})} className="w-full p-2 rounded bg-[#020817] border border-gray-700">
<option value={1}>Sí</option>
<option value={0}>No</option>
</select>
</div>
</div>


<div className="flex gap-2">
<label className="flex items-center gap-2 text-sm">
<input type="checkbox" checked={!!form.requires_approval} onChange={e => setForm({...form, requires_approval: e.target.checked ? 1 : 0})} />
Requiere aprobación
</label>
<label className="flex items-center gap-2 text-sm">
<input type="checkbox" checked={!!form.requires_room} onChange={e => setForm({...form, requires_room: e.target.checked ? 1 : 0})} />
Requiere sala
</label>
</div>
</>
)}
/>
);
}


export default ServicesPage;
